import Vue from 'vue';
import Vuex, { MutationTree, ActionTree, GetterTree } from 'vuex';

import { Section, UserPrivacyState } from '../models/store-viewmodel';
import { root } from '@/shared/store/index';
import { Config } from '../models/config-viewmodel';
import { UserPrivacy } from '../models/user-privacy-viewmodel';

Vue.use(Vuex);

const state: UserPrivacyState = {
    loading: true,
    error: '',
    config: {
        language: '',
        labels: {},
        apiBasePath: ''
    },
    formSection: {
        privacy: new Section(),
    },
    privacyData: {
        showMobilePhoneNumber: false,
        showRoomNumber: false,
        showWorkPhoneNumber: false
    },
    formData: {
        privacyData: new UserPrivacy(false, false, false),
    }
}

const mutations: MutationTree<UserPrivacyState> = {
    setConfig(state, config: Config) {
        state.config = config;
    },

    setLoading(state, loading: boolean) {
        state.loading = loading;
    },

    setError(state, error: string) {
        state.error = error;
    },

    setPrivacyData(state, data: UserPrivacy) { 
        Vue.set(state, 'privacyData', data);
    },

    setFormSectionOpen(state, data: { type: string, status: boolean }) {
        state.formSection[data.type].open = data.status;
    },

    setFormSectionLoading(state, data: { type: string, status: boolean }) {
        state.formSection[data.type].loading = data.status;
    },

    setFormSectionSubmitted(state, data: { type: string, status: boolean }) {
        state.formSection[data.type].submitted = data.status;
    },

    setFormSectionSuccess(state, data: { type: string, status: boolean }) {
        state.formSection[data.type].success = data.status;
    },

    setFormSectionError(state, data: { type: string, status: boolean }) {
        state.formSection[data.type].error = data.status;
    },

    setFormSectionFieldErrors(state, data: { type: string, errors: [] }) {
        state.formSection[data.type].fieldErrors = data.errors;
    },

    setFormDataPrivacy(state, data: UserPrivacy) {
        state.formData.privacyData = data;
    },
}

const actions: ActionTree<UserPrivacyState, UserPrivacyState> = {
    formSectionOpen({ commit, getters }, data: { type: string, status: boolean }) {

        if (data.type === 'privacy') {
            commit('setFormDataPrivacy', JSON.parse(JSON.stringify(getters.privacyData)));
        }

        commit('setFormSectionOpen', { type: data.type, status: data.status })

        if (data.status === true) {
            commit('setFormSectionSubmitted', { type: data.type, status: false });
            commit('setFormSectionSuccess', { type: data.type, status: false });
            commit('setFormSectionError', { type: data.type, status: false });
        }
    }
}

const getters: GetterTree<UserPrivacyState, UserPrivacyState> = {
    config(state) {
        return state.config;
    },

    loading(state) {
        return state.loading;
    },

    error(state) {
        return state.error;
    },

    sectionLoading: (state) => (type: string): boolean => {
        return state.formSection[type].loading;
    },

    sectionFormOpen: (state) => (type: string): boolean => {
        return state.formSection[type].open;
    },

    sectionSuccess: (state) => (type: string): boolean => {
        return state.formSection[type].success;
    },

    sectionError: (state) => (type: string): boolean => {
        return state.formSection[type].error;
    },

    sectionFormSubmitted: (state) => (type: string): boolean => {
        return state.formSection[type].submitted;
    },

    dataComparison: (state) => (dateOne: any, dataTwo: any): boolean => {
        return !(JSON.stringify(dateOne) === JSON.stringify(dataTwo));
    },

    privacyDataModified(state, getters): boolean {
        return getters.privacyData ?
            getters.dataComparison(getters.privacyData, state.formData.privacyData) :
            getters.dataComparison(new UserPrivacy(false, false, false), state.formData.privacyData);
    },

    privacyData(state) {
        return state.privacyData;
    },

    formData(state) {
        return state.formData;
    },

    formSection(state) {
        return state.formSection;
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        root
    }
})